import type { CountryRef } from '@gat-ship/types'
import { getCountryRefsRequest } from '../model/country-api-calls'
import { createListRefDataSource } from './create-list-ref-datasource'

/** Shared country ref cache for select/combobox pickers. */
export const countryRefDataSource = createListRefDataSource<CountryRef>({
  fetch: getCountryRefsRequest,
  getKey: (country) => country.code,
  debounceMs: 0
})
